/**
 * 목록 필터 선택지 API — Partner Filters. 페이징 없음.
 */
import { createApiPath } from '@/shared/api/endpoints';
import { apiClient } from '@/shared/api/http-client';

/** 담당자 선택지 — 05 사용자 목록과 같은 집합, 업체명 → 사용자 ID 순 */
export interface UserOption {
  userId: number;
  companyName: string;
  representativeName: string;
}

/** 시/도별 시/군/구 선택지 — 노출 거래처 병의원 주소 기준(폐업 포함) */
export interface RegionOption {
  /** 정규화된 시/도 (예: 경기도) */
  sido: string;
  /** 세종은 빈 배열 */
  sigungu: string[];
}

/** 제약사 선택지 — 거래처 정보(오늘 귀속) 거래의 제약사, 제약사명 → ID 순 */
export interface PharmaCompanyOption {
  pharmaCompanyId: number;
  pharmaCompanyName: string;
}

export const filterService = {
  /** GET /partner/filters/users */
  users: async () => {
    const { data } = await apiClient.get<UserOption[]>(
      createApiPath.filters.users(),
    );
    return data;
  },

  /** GET /partner/filters/regions */
  regions: async () => {
    const { data } = await apiClient.get<RegionOption[]>(
      createApiPath.filters.regions(),
    );
    return data;
  },

  /** GET /partner/filters/pharma-companies */
  pharmaCompanies: async () => {
    const { data } = await apiClient.get<PharmaCompanyOption[]>(
      createApiPath.filters.pharmaCompanies(),
    );
    return data;
  },
};
